import type { AppState } from '../core/types';
import { breadcrumbForScope, navigateUpTarget, type Crumb, type NavigationTarget } from '../domain/navigation';
import { icon } from './icons';

const esc = (value: string): string => value.replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char] ?? char);

/** "CASUR > José Andrés Pérez > Suerte 14" with one-step back navigation. */
export class Breadcrumb {
  private crumbs: readonly Crumb[] = [];
  private up: NavigationTarget | null = null;
  private key = '';

  constructor(private readonly element: HTMLElement, private readonly navigate: (target: NavigationTarget) => void) {
    element.addEventListener('click', (event) => {
      const target = event.target as Element;
      if (target.closest('[data-crumb-back]')) { if (this.up) this.navigate(this.up); return; }
      const crumb = target.closest<HTMLElement>('[data-crumb]');
      if (!crumb) return;
      const value = this.crumbs[Number(crumb.dataset.crumb)];
      if (value && !value.current) this.navigate(value);
    });
  }

  render(state: Pick<AppState, 'model' | 'workScope' | 'entityViewLevel'>): void {
    const key = [state.model?.id ?? '', state.workScope.fincaIds.join(','), state.workScope.suerteIds.join(','), state.workScope.tablonIds.join(','), state.entityViewLevel].join('|');
    if (key === this.key) return;
    this.key = key;
    this.crumbs = breadcrumbForScope(state.model, state.workScope, state.entityViewLevel);
    this.up = this.crumbs.length > 1 ? navigateUpTarget(state.model, state.workScope, state.entityViewLevel) : null;
    if (!this.crumbs.length) { this.element.innerHTML = ''; return; }
    const back = this.up ? `<button type="button" class="crumb-back" data-crumb-back title="Volver al nivel anterior" aria-label="Volver al nivel anterior">${icon('chevronLeft')}</button>` : '';
    this.element.innerHTML = back + this.crumbs.map((crumb, index) => `${index ? `<span class="crumb-sep">${icon('chevronRight')}</span>` : ''}<button type="button" data-crumb="${index}"${crumb.current ? ' aria-current="page"' : ''}>${esc(crumb.label)}</button>`).join('');
  }
}
